import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.spacing(1),

      '& .MuiOutlinedInput-notchedOutline': {
        top: 0,
        borderColor: theme.palette.divider,
        transition: 'border-color 0.2s, border-width 0.1s',

        '& legend': { display: 'none' },
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.divider,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
      },

      '&.Mui-disabled': {
        cursor: 'not-allowed',

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.divider,
        },
        '& svg': { color: colors.black[300] },
      },

      '&.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: colors.red[300] },
      '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.red[500],
        borderWidth: '2px',
      },
    }),
  },
};
